import { getAuthAxiosBackend } from "@/helpers/axios"

class LevelOneServices {
    get(id) {
        return getAuthAxiosBackend().get('LevelOne/getLevelOneById/' + id.toString())
    }

    getAll(data = {}) {
        return getAuthAxiosBackend().get('LevelOne/all', { params: data })
    }

    add(data) {
        return getAuthAxiosBackend().post('LevelOne/addLevelOne', data)
    }

    edit(id, data) {
        return getAuthAxiosBackend().put('LevelOne/updateLevelOne/' + id, data)
    }

    restore(id, data) {
        return getAuthAxiosBackend().put('LevelOne/restoreLevelOne' + id, data)
    }

    delete(id) {
        return getAuthAxiosBackend().delete('LevelOne/softDeleteLevelOne/' + id.toString())
    }

    forceDelete(id) {
        return getAuthAxiosBackend().delete('LevelOne/deleteLevelOne/' + id.toString())
    }
}

export default new LevelOneServices()
